module.exports = __webpack_public_path__ + "static/media/icon_round-close-24px.388eb904.svg";